import Widget from './src/Widget.vue'

Widget.install = function (Vue) {
  Vue.component(Widget.name, Widget)
}

export default Widget



// WEBPACK FOOTER //
// ./src/packages/widget/index.js